// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1EhYC","visuallyhidden":"_3IkXn","hide-text":"_1gzke","center":"Cb4da","noprint":"_1bmNr","root":"_22QIw","image":"_1i3fT","alternateImagePosition":"_3SfHN","content":"zn8v8","label":"z8zKn"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-teaser-small/styles/Teaser.scss
 ** module id = 956
 ** module chunks = 1
 **/